import{a as i}from"./ninox-components-7GX5U3C4.js";import{l as t}from"./ninox-components-GQTCIGTF.js";import{f as o}from"./ninox-components-MYF6AQNE.js";import{g as r}from"./ninox-components-X4NEROUJ.js";import e from"styled-components";var n=e(i)`
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    opacity: 0.75;
`;n.defaultProps={animationDuration:2,borderWidth:o.medium,color:r.neutral[1e3],size:t.l,style:{}};export{n as a};
//# sourceMappingURL=ninox-components-LA7MQ5BN.js.map